import { useContext } from 'react'
import { Web3Context } from '../contexts/Web3Context'

// ----------------------------------------------------------------------

const useWeb3 = () => {
	const context = useContext(Web3Context)

	if (!context) throw new Error('Web3 context must be use inside Web3Provider')

	return context
}

export default useWeb3
